import React, { Component } from 'react';
require('./Icon.scss');
class Icon extends Component {
    render() {
        if(this.props.route) {
            return (
                <a key={this.props.title} href={this.props.route} className={"Icon " + this.props.classes} title={this.props.title} target="_blank">
                    <i className={this.props.icon}></i>
                </a>
            )
        } else {
            return (
                <span key={this.props.title} className={"Icon " + this.props.classes} title={this.props.title}>
                    <i className={this.props.icon}></i>
                </span>
            )
        }
    }
}

export default Icon;



/** WEBPACK FOOTER **
 ** ./src/components/Icon/Icon.js
 **/